import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import TagIcon from '@mui/icons-material/Tag'
import AlignVerticalCenterIcon from '@mui/icons-material/AlignVerticalCenter'

import { SmallBodyText } from '../styles/Text'
import { FlexColumn } from '../styles/Containers'
import { theme } from '../../themes/theme'

const MetricList = styled(FlexColumn)`
  gap: 8px;
`

const MetricRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 15px;
  line-height: 15px;
`

const MetricIcon = styled.span`
  display: inline-flex;
  align-items: center;
  color: ${theme.colors.text.body};
  flex-shrink: 0;

  .MuiSvgIcon-root {
    font-size: 15px;
  }
`

function MetricItems({ items }) {
  return (
    <MetricList>
      {items.map(item => {
        const isAverage = item.startsWith('Average')
        const Icon = isAverage ? AlignVerticalCenterIcon : TagIcon
        return (
          <MetricRow key={item}>
            <MetricIcon>
              <Icon data-testid={isAverage ? 'average-metric-icon' : 'count-metric-icon'} aria-hidden />
            </MetricIcon>
            <SmallBodyText>{item}</SmallBodyText>
          </MetricRow>
        )
      })}
    </MetricList>
  )
}

MetricItems.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired
}

export default MetricItems
